import { render } from "./Result.vue?vue&type=template&id=6d32e3de&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=6d32e3de&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d32e3de"]])

export default __exports__